import { Injectable } from '@angular/core';
import { StatsigService } from '@services/statsig.service';

export enum REPORTS_FEATURE_FLAGS {
    SLB_ACCESS_SHUTDOWN = 'slb-access-shutdown',
}

@Injectable({ providedIn: 'root' })
export class SmartLoadBoardFeatureFlagService {
  constructor(
    private statsigService: StatsigService,
  ) {}

  public isSlbAccessShutdownEnabled(): boolean {
    return this.statsigService.evaluateGate(REPORTS_FEATURE_FLAGS.SLB_ACCESS_SHUTDOWN);
  }
}
